<script setup lang="ts">
import { explainMonsterAffix } from '@/core/monster/affix'
import { useUserStore } from '@/stores/modules/user'
import type { PersonMonsterType } from '@/types/monster'
import { socketEmitAsync } from '@/utils/web-socket'
import { QuestionFilled } from '@element-plus/icons-vue'
import { guideFightTips } from '../data'

const userStore = useUserStore()

defineProps<{ monster?: PersonMonsterType }>()
const emits = defineEmits(['start'])

async function handleStart() {
  await socketEmitAsync<PersonMonsterType>({ type: 'startGuide' })
  emits('start')
}
</script>

<template>
  <div class="border-wrap eternal-tower">
    <h4 class="special">
      引导副本
      <div class="help-info" style="margin-left: 5px">
        <el-popover placement="top" width="100%" trigger="click">
          <template #reference>
            <el-icon size="20"><QuestionFilled /></el-icon>
          </template>
          <div class="affix">
            <h4>引导副本说明</h4>
            <p>
              1. 引导副本用于帮助新手玩家快速熟悉游戏，在其中您将遭遇各样的怪物，并应对一些怪物机制，完成挑战将获得<span class="info">丰厚奖励</span
              >。
            </p>
            <p>2. 您需要在<span class="info">3分钟</span>的时间内通过挑战，进入后切装无效，请提前根据怪物属性搭配合理的装备。</p>
            <p>3. 引导副本当前最高为 <span class="info">10</span>级，完成全部层级后，将<span class="info">关闭副本入口</span>。</p>
          </div>
        </el-popover>
      </div>
    </h4>
    <p>当前层级：{{ userStore.guideFightIndex + 1 }}</p>
    <p class="affix">提示：<span v-html="guideFightTips[userStore.guideFightIndex]"></span></p>
    <p>
      当前怪物：
      <el-popover placement="bottom" :width="300" trigger="click" popper-class="monster-detail" :teleported="false" :disabled="!monster">
        <template #reference>
          <el-button size="small" type="danger" plain>
            <span v-show="monster">{{ monster?.name }}</span>
            <span v-show="!monster">暂无战斗</span>
          </el-button>
        </template>
        <div class="monster-detail">
          <h3 style="margin: 5px 0">{{ monster?.name }}</h3>
          <p>血量：{{ monster?.hp }}</p>
          <p>防御：{{ monster?.def }}</p>
          <p>闪避率：{{ monster?.evs }}%</p>
          <p>抗爆率：{{ monster?.crtdef }}%</p>
          <template v-if="monster?.special?.length">
            <p>特性：</p>
            <p v-for="item of explainMonsterAffix(monster.special)" v-html="item"></p>
          </template>
        </div>
      </el-popover>
    </p>
    <div style="margin: 10px 0">
      <el-button type="success" plain @click="handleStart"> 进入 </el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.eternal-tower {
  flex-flow: column;
}
</style>
